import React, { Component, PropTypes, PureComponent } from 'react';
import { hashHistory, IndexRedirect, Redirect, Route, Router } from 'react-router';
import { render } from 'react-dom';
import SessionsPage from '../../FastRecruit/components/SessionsPage';
import NotFoundPage from '../../common/components/NotFoundPage';
import NotificationSystem from '../../NotificationSystemProvider';
import AdminTourneyPage from './pages/AdminTourneyPage';
import AdminTourneyStructure from './pages/AdminTourneyStructure';
import LiLink from '../../components/LiLink';
import { Absolute } from '../../common/components/Fill';
import AdminGamesListPage from './pages/AdminGamesListPage';
import { Button } from 'react-fast-ui';
import cx from 'classnames';
import OutlierGamesPage from './pages/OutlierGamesPage';
import AdminTourneyDivisionList from './pages/AdminTourneyDivisionList';
import AdminTourneyBracketList from './pages/AdminTourneyBracketList';
import AdminBracketPage from './pages/AdminBracketPage';
import LoadGameRedirect from './pages/LoadGameRedirect';
import { pageView } from '../../util/tracking/GoogleAnalytics';
import _ from 'underscore';
import SuperAdminFeature from '../../common/access/SuperAdminFeature';

const NoAddTourneySessionPage = props => (
  <SessionsPage {...props} showAddTourney={false} showAccountInfo={false} tourneyParams={{ custom: false }}/>
);

class Nav extends Component {
  static contextTypes = {
    model: PropTypes.object.isRequired,
    onTokenChange: PropTypes.func.isRequired
  };

  state = { expanded: false };

  logOut = () => this.context.onTokenChange(null);
  toggleExpanded = () => this.setState({ expanded: !this.state.expanded });

  render() {
    const { model } = this.context;
    const { expanded } = this.state;

    return (
      <nav className="navbar navbar-inverse navbar-static-top">
        <div className="container-fluid">
          <div className="navbar-header display-flex align-items-center">
            <div className="flex-grow-1">
              <a className="navbar-brand">
                GameDay
                <small> {__VERSION__}</small>
              </a>
            </div>
            <div className="flex-shrink-0">
              <span className="visible-xs-inline">
                <Button icon="bars" borderless={true} onClick={this.toggleExpanded}/>
              </span>
            </div>
          </div>

          <span className={cx({ 'hidden-xs': !expanded })}>
            <ul className="nav navbar-nav">
              <LiLink to="sessions">Tourneys</LiLink>
              <SuperAdminFeature>
                <LiLink to="outlier-games">Outlier Games</LiLink>
              </SuperAdminFeature>
            </ul>
            <div className="navbar-right" style={{ marginRight: 0 }}>
              <p className="navbar-text">Signed in as {model.getName()}</p>
              <ul className="nav navbar-nav">
                <li onClick={this.logOut}><a href="#" onClick={e => e.preventDefault()}>Sign Out</a></li>
              </ul>
            </div>
          </span>
        </div>
      </nav>
    );
  }
}

// so we don't get the error
const NoPassThroughAbsolute = ({ children }) => <Absolute>{children}</Absolute>;

// the navbar and the notification system wrapped around the children
class AppWrapper extends PureComponent {
  render() {
    const { children, location: { key } } = this.props;

    return (
      <div style={{ minHeight: '100%', width: '100%' }} className="display-flex flex-direction-column">
        <div className="flex-shrink-0">
          <Nav key={key}/>
        </div>

        <NotificationSystem className="flex-grow-1 position-relative">
          <NoPassThroughAbsolute>{children}</NoPassThroughAbsolute>
        </NotificationSystem>
      </div>
    );
  }
}

const handleUpdate = _.debounce(() => {
  localStorage.setItem('last_path', window.location.hash.substr(1));
  pageView(window.location.hash);
}, 100);

export default class GameDayRouter extends PureComponent {
  // the last path that the user accessed is stored in localStorage so we can bring them back if they go to the base url
  _lastPath = localStorage.getItem('last_path') || 'sessions';

  render() {
    return (
      <Router history={hashHistory} onUpdate={handleUpdate}>
        <Route component={AppWrapper}>
          <IndexRedirect from="" to={this._lastPath}/>
          <Redirect from="/" to={this._lastPath}/>

          <Route component={OutlierGamesPage} path="outlier-games"/>

          <Route component={NoAddTourneySessionPage} path="sessions">
            <Route path=":sessionId" component={SessionsPage.Tourneys}/>
          </Route>

          <Route component={AdminTourneyPage} path="tourneys/:tourneyId">
            <IndexRedirect from="" to="games"/>
            <Route path="structure" component={AdminTourneyStructure}>
              <Route path=":data"/>
            </Route>
            <Route path="games" component={AdminGamesListPage}>
              <Route path=":data"/>
            </Route>

            <Route path="brackets" component={AdminTourneyDivisionList}>
              <Route path=":divisionId" component={AdminTourneyBracketList}>
                <Route path=":bracketId" component={AdminBracketPage}/>
              </Route>
            </Route>

            <Route path="*" component={NotFoundPage}/>
          </Route>

          <Route component={LoadGameRedirect} path="to-game/:gameId"/>

          <Route component={NotFoundPage} path="*"/>
        </Route>
      </Router>
    );
  }
};



// WEBPACK FOOTER //
// ./src/js/GameDay/components/GameDayRouter.jsx